import { createContext } from 'react';

const premiumBlockContext = createContext();

export default premiumBlockContext;
